<template>
<div id="allBox" class="all-box">
    <router-view ref="routerView" v-if="isRouterAlive"></router-view>
</div>
</template>

<script>
import login from '@/components/login';
import mcProject from '@/components/mc_project';
import turnPage from '@/components/turn_page';
import turnLoginPage from '@/components/turn_login_page';
export default {
    name: 'allBox',
    data() {
        return {
            isRouterAlive: true
        }
    },
    provide() {
        return {
            reload: this.reload
        }
    },
    components: {
        turnLoginPage,
        turnPage,
        login,
        mcProject
    },
    methods: {
        reload() {
            this.isRouterAlive = false;
            this.$nextTick(function () {
                this.isRouterAlive = true;
            })
        },
        callback(result) {
            if (result.status == 200) {
                let driveId = result.drive.id;
                let rootId = result.drive.rootId;
                localStorage.setItem("driveId", driveId);
                localStorage.setItem("rootId", rootId);
                window.location.reload();
            }
        },
        //判断user过期
        expiration(){
            var user = JSON.parse(localStorage.getItem("user"));
            if(user){
                //获取当前时间
                var nData = new Date().getTime();
                //获取过期时间
                var eData = localStorage.getItem("expirationTime") * 1;
                //仅在有过期时间时进行判断
                if(eData&&(nData>eData)){
                     var psd = localStorage.getItem(user.id+'interimPsd');
                     var newSign = localStorage.getItem("noviceGuide"+user.id);
                    //已过期则清除缓存（可以添加退出登录）或没有指定过期时间
                    localStorage.clear();
                     if(psd){
                      localStorage.setItem(user.id+"interimPsd",psd);
                     }
                     //防止新手引导再次弹窗
                     if(newSign){
                      localStorage.setItem("noviceGuide"+user.id,true);
                     }
                }
            }
        },
    },
    mounted(){
        //进入页面判断user是否过期
        this.expiration();
        //退出页面判断user是否过期
        window.addEventListener('Onbeforeunload', function (e) {
            this.expiration();
        })
    },
    created(){
        
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue